var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("CargoMsg.Cargo_MOMAOB"),
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("span", { staticStyle: { "margin-right": "10px" } }, [
        _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_AccountTitleName")))
      ]),
      _c("el-input", {
        staticStyle: { width: "200px", "margin-bottom": "5px" },
        attrs: {
          disabled: "",
          value: _vm.accountTitle
            ? _vm.accountTitle.accountTitle +
              " " +
              _vm.accountTitle.accountTitleName
            : ""
        }
      }),
      _c(
        "div",
        { staticClass: "section row-grid" },
        [
          _c("cargo-ag-grid", {
            staticStyle: { "min-height": "500px" },
            attrs: {
              "grid-params": _vm.gridParams,
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.accountTitleAuxiliaryBalances
            },
            on: {
              "update:gridParams": function($event) {
                _vm.gridParams = $event
              },
              "update:grid-params": function($event) {
                _vm.gridParams = $event
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: { click: _vm.addAuxiliaryEvent }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Add")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "danger" },
              on: { click: _vm.removeAuxiliaryEvent }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: { click: _vm.saveAuxiliaryEvent }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.closeHandler } },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Close")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }